export default "__VITE_ASSET__B74ukfm0__"